import { type Tenants } from '@gp/base'

import { apiClient } from '@/api/client'

import type { GameIDs } from './types'

interface AgreementsResponse {
  date_agreement_participation: string | null
}

export const getAgreements = async (
  network: Tenants,
  gameId: GameIDs = 'esum',
): Promise<AgreementsResponse> => {
  const response = await apiClient.instance.get<AgreementsResponse>(
    `/v1/${gameId}/agreements`,
    { params: { network } },
  )
  return response.data
}
